import React from 'react';

export const IndexCell = ({ row: { index } }) => (
  <div className="flex justify-center items-center h-full">
    <div className="w-5 h-5 bg-gray-100 rounded flex justify-center items-center text-xs">{index + 1}</div>
  </div>
);
